import { Box, CircularProgress } from "@mui/material";
import React from "react";

const MuPb = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <CircularProgress />
    </Box>
  );
};

export default MuPb;
